import profiles from './sponsorPresentation.json'

// 公开品牌内容独立于账户数据；路径保留参考站大小写，支持刷新与浏览器前进后退。
export const sponsorProfiles = Object.freeze(profiles)
export function resolveSponsorProfile(path) {
  return sponsorProfiles.find(profile => profile.path.toLowerCase() === String(path).toLowerCase()) || sponsorProfiles[0]
}
export function sponsorAsset(path) {
  return path?.startsWith('/reference/') ? `${import.meta.env.BASE_URL}${path.slice(1)}` : ''
}
